module.exports = __webpack_public_path__ + "static/media/exit-popup.74e1678a.svg";